// @stayai — §2c4 spill fix: Fly Bundles "Buy More, Save More" Subscribe & Save dropdown
// enumerates product.selling_plan_groups client-side with no app_id filter. 
// Active app id: single source snippets/active-subscription-app-id.liquid, passed in as
// window.STAYAI_ACTIVE_APP_ID from theme.liquid. 
(function () {
  var ACTIVE_APP_ID = String(window.STAYAI_ACTIVE_APP_ID || '').trim();
  if (!ACTIVE_APP_ID) return; // no toggle value -> do nothing
  var DEBUG = window.STAYAI_FLYBUNDLES_DEBUG || false;

  // Selling plans meant only for the LSG bundle-builder flow can still get attached to a
  // regular (non-bundle) product's selling_plan_groups — e.g. a "10% off bundle" group
  // living alongside a "10% off every 1/2/3m*" group on the same product, both app_id 5859381.
  // The app_id filter above has nothing to say about that (both are the active app) so these
  // terms hide bundle-only frequencies from a *regular* PDP's Subscribe & Save dropdown.
  var terms_to_hide_pdp_subs_freq = ['bundle', 'pack'];

  function log() {
    if (DEBUG) console.log.apply(console, ['>>> [flybundles-filter]'].concat(Array.prototype.slice.call(arguments)));
  }

  function matchesHiddenTerm(text) {
    var lower = String(text || '').toLowerCase();
    return terms_to_hide_pdp_subs_freq.some(function (term) {
      return lower.indexOf(term) !== -1;
    });
  }

  // A selling plan is hidden from the PDP frequency dropdown if any of: its own name, its
  // option name(s)/value(s), or its owning group's name contain a term_to_hide_pdp_subs_freq
  // word — regardless of app_id (a bundle-only plan can belong to the active app and still
  // not belong on a regular product's dropdown).
  function buildMaps() {
    var groups = window.ALL_SELLING_PLAN_GROUPS || [];
    var appIdMap = {};
    var hideByTermMap = {};
    groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) {
        appIdMap[String(p.id)] = g.app_id;

        var searchable = [g.name, p.name];
        (p.options || []).forEach(function (o) {
          searchable.push(o.name);
          searchable.push(o.value);
        });
        if (matchesHiddenTerm(searchable.join(' '))) {
          hideByTermMap[String(p.id)] = true;
        }
      });
    });
    return { appIdMap: appIdMap, hideByTermMap: hideByTermMap };
  }

  function filterSelect(select, maps) {
    if (select.dataset.stayFiltered) return;
    var selectedForeign = false;
    Array.prototype.slice.call(select.options).forEach(function (opt) {
      var appId = maps.appIdMap[opt.value];
      var hiddenByTerm = maps.hideByTermMap[opt.value] === true;
      if ((appId !== undefined && appId !== ACTIVE_APP_ID) || hiddenByTerm) {
        if (opt.selected) selectedForeign = true;
        if (hiddenByTerm) log('hiding bundle/pack-term plan', opt.value, opt.textContent);
        opt.remove();
      }
    });
    if (selectedForeign || !select.value) {
      var fallback = select.querySelector('option');
      if (fallback) {
        select.value = fallback.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        var wrapper = select.closest('.gfbDropdownWithCustomIcon');
        var label = wrapper && wrapper.querySelector('.gfbSelectedOption');
        if (label) label.textContent = fallback.dataset.sellingPlanName || fallback.textContent;
      }
    }
    select.dataset.stayFiltered = 'true';
    log('filtered', select);
  }

  function scan(root, maps) {
    root.querySelectorAll("select.gfbSelect[data-is-event-registered='REGISTERED']").forEach(function (select) {
      filterSelect(select, maps);
    });
  }

  function init() {
    var root = document.querySelector('.gfbPageWrapper');
    if (!root) return;
    var maps = buildMaps();
    if (!Object.keys(maps.appIdMap).length) {
      log('no ALL_SELLING_PLAN_GROUPS found — skipping filter');
      return;
    }
    scan(root, maps);
    new MutationObserver(function () {
      scan(root, maps);
    }).observe(root, { childList: true, subtree: true });
  }

  function waitForRoot(attempts) {
    var root = document.querySelector('.gfbPageWrapper');
    if (root) return init();
    if (attempts <= 0) return log('gfbPageWrapper never appeared — exiting');
    setTimeout(function () { waitForRoot(attempts - 1); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForRoot(40); });
  } else {
    waitForRoot(40);
  }
})();
